// getOrders returns a list of order (object)
// for the given orders state.
const getOrders = ({ ids = [], data = {} }) => ids.map(id => data[id]);

export { getOrders };
